// Chart colours in the order the design assigns them: the first value gets the first colour, and so on.
export const ALLOCATION_CHART_COLORS = [
  "#028FFC",
  "#F26B03",
  "#DA66D6",
  "#00AC42",
  "#8461D6",
  "#E43F38",
  "#3DA496",
  "#B06035",
  "#F3C200",
  "#7126F1",
  "#009688",
  "#601F74",
] as const;

export const allocationChartColor = (index: number): string =>
  ALLOCATION_CHART_COLORS[index % ALLOCATION_CHART_COLORS.length] ??
  ALLOCATION_CHART_COLORS[0];
